import {
    COMMITTEE_LIST,
    COMMITTEE_ADDEDIT,
    COMMITTEE_CHANGE_STATUS,
    COMMITTEE_GETONE,
    COMMITTEE_DELETE,
    ALLDESIGNATION_LIST,
    ALLUSER_LIST,
    ALLDISTRICT_LIST,
    ALLTALUKA_LIST,
    ALLVILLAGE_LIST,
    COMMITTEE_EXPORT
} from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const committeeListApi = (payload) => {
    return apiInstance.post(COMMITTEE_LIST, payload, {
        headers: authHeader(),
    });
};

export const committeeChangeStatusApi = (payload) => {
    return apiInstance.post(COMMITTEE_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditCommitteeApi = (payload) => {
    return apiInstance.post(COMMITTEE_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const committeeDeleteApi = (payload) => {
    return apiInstance.post(COMMITTEE_DELETE, payload, {
        headers: authHeader(),
    });
};

export const GetoneCommitteeApi = (payload) => {
    return apiInstance.post(COMMITTEE_GETONE, payload, {
        headers: authHeader(),
    });
};

export const GetAllDesignationApi = (payload) => {
    return apiInstance.get(ALLDESIGNATION_LIST, {
        headers: authHeader(),
        params: payload
    });
};

export const GetAllUserApi = (payload) => {
    return apiInstance.get(ALLUSER_LIST, {
        headers: authHeader(),
        params: payload
    });
};

export const GetAllDistrictApi = (payload) => {
    return apiInstance.get(ALLDISTRICT_LIST, {
        headers: authHeader(),
        params: payload
    });
};

export const GetAllTalukaApi = (payload) => {
    return apiInstance.get(ALLTALUKA_LIST, {
        headers: authHeader(),
        params: payload
    });
};

export const GetAllVillageApi = (payload) => {
    return apiInstance.get(ALLVILLAGE_LIST, {
        headers: authHeader(),
        params: payload
    });
};

export const committeeExportApi = (payload) => {
    return apiInstance.post(COMMITTEE_EXPORT, payload, {
        headers: authHeader(),
    });
};